import { mutate } from '../../../../../../../common/graphql';
import { ADMIN_GAME_QUERY } from '../../../../../../../common/graphql/games/game-admin-graphql';
import { GET_SUBMISSION_QUERY } from '../../gql/submission-graphql';
import {
  ADMIN_SUBMISSION_SYNC_COVER_MUTATION,
  AdminSubmissionSyncCoverInput,
  AdminSubmissionSyncCoverMutation,
} from '@crazygames/graph-types/submission/admin-submission-sync-cover-input.type';

export function synchroniseCover(input: AdminSubmissionSyncCoverInput, gameSlug: string) {
  return mutate<AdminSubmissionSyncCoverInput, AdminSubmissionSyncCoverMutation>(ADMIN_SUBMISSION_SYNC_COVER_MUTATION, input, {
    refetchQueries: [
      { query: ADMIN_GAME_QUERY, variables: { slug: gameSlug } },
      { query: GET_SUBMISSION_QUERY, variables: { id: input.id } },
    ],
    awaitRefetchQueries: true,
  });
}
